export enum StepStateEnum {
    Disabled = 0,
    Active = 1,
    Completed = 2,
}

export class WorkflowStepConfig {
    Id: number;
    /** Transloco key; the step title is resolved by the pipe in the templates that show it. */
    NameKey: string;
    State: StepStateEnum;
    CompletedBy?: string;
    CompletedOn?: string;
    DueDate?: string;
    AssignedUsers: string[];
}
